import React from "react";

import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";

import { AnimatePresence } from "framer-motion";
import { ThemeProvider } from "styled-components";
import { HelmetProvider } from "react-helmet-async";

import ScrollToTop from "./components/common/ScrollToTop";

/* MAIN PAGES */
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ServicesPage from "./pages/ServicesPage";
import PricingPage from "./pages/PricingPage";
import Projects from "./pages/Projects.jsx";
import CaseStudies from "./pages/CaseStudies";
import BlogPage from "./pages/BlogPage";
import Careers from "./pages/CareersPage";
import Contact from "./pages/ContactPage";

/* SEO PAGES */
import EcommerceDevelopment from "./pages/seo/EcommerceDevelopment";
import MobileAppDevelopment from "./pages/seo/MobileAppDevelopment";
import CRMSolutions from "./pages/seo/CRMSoftwareDevelopment.jsx";
import AISolutions from "./pages/seo/AISoftwareSolutions.jsx";
import DashboardDevelopment from "./pages/seo/CustomDashboardDevelopment.jsx";

/* GLOBAL CUSTOMER CONTACT */
import WhatsAppFloatingButton from "./components/home/WhatsAppFloatingButton.jsx";
import ConsultationBot from "./components/BOT/ConsultationBot.jsx";

/* ADMIN */
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import LeadManagement from "./pages/admin/LeadManagement";

/* GLOBAL */
import "./styles/global.css";
import GlobalLayout from "./layouts/GlobalLayout";
import theme from "./styles/theme";

function App() {
  return (
    <HelmetProvider>

      <ThemeProvider theme={theme}>

        <Router>

          <ScrollToTop />

          <AnimatePresence mode="wait">

            <Routes>

              {/* =====================================================
                  PUBLIC WEBSITE
              ====================================================== */}

              <Route element={<GlobalLayout />}>

                {/* MAIN PAGES */}

                <Route
                  path="/"
                  element={<HomePage />}
                />

                <Route
                  path="/about"
                  element={<AboutPage />}
                />

                <Route
                  path="/services"
                  element={<ServicesPage />}
                />

                <Route
                  path="/pricing"
                  element={<PricingPage />}
                />

                <Route
                  path="/projects"
                  element={<Projects />}
                />

                <Route
                  path="/case-studies"
                  element={<CaseStudies />}
                />

                <Route
                  path="/blog"
                  element={<BlogPage />}
                />

                <Route
                  path="/careers"
                  element={<Careers />}
                />

                <Route
                  path="/contact"
                  element={<Contact />}
                />

                {/* =================================================
                    SEO LANDING PAGES
                ================================================== */}

                <Route
                  path="/ecommerce-development"
                  element={<EcommerceDevelopment />}
                />

                <Route
                  path="/mobile-app-development"
                  element={<MobileAppDevelopment />}
                />

                <Route
                  path="/crm-software-development"
                  element={<CRMSolutions />}
                />

                <Route
                  path="/ai-software-solutions"
                  element={<AISolutions />}
                />

                <Route
                  path="/custom-dashboard-development"
                  element={<DashboardDevelopment />}
                />

              </Route>

              {/* =====================================================
                  ADMIN
              ====================================================== */}

              <Route
                path="/admin/login"
                element={<AdminLogin />}
              />

              <Route
                path="/admin"
                element={<AdminDashboard />}
              />

              <Route
                path="/admin/leads"
                element={<LeadManagement />}
              />

            </Routes>

          </AnimatePresence>

          {/* =====================================================
              GLOBAL CUSTOMER CONTACT
          ====================================================== */}

          <ConsultationBot />

          <WhatsAppFloatingButton />

        </Router>

      </ThemeProvider>

    </HelmetProvider>
  );
}

export default App;